import * as React from 'react';

export default () => (
  <div className="flex flex-col items-center justify-center h-screen">
    <p className="uppercase text-grey-darker text-lg tracking-wide mb-6">
      Loading
    </p>
    <div className="loader opacity-25 w-64 h-2px" />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/AppLoading.tsx